module.exports = __webpack_public_path__ + "images/icons_v2/auto-lock-alternative-1197124f.svg";